import { Button, Flex } from 'antd'
import Image from 'next/image'
import type { FunctionComponent } from 'react'
import styled from 'styled-components'
import { FeatureFlag } from '@/api/user-api'
import campaignIntroSrc from '@/assets/images/campaign-intro.png'
import RequestTrialButton from '@/components/campaign/common/request-trial-button'
import routes from '@/hooks/use-authorization/routes'
import useFeatureFlags from '@/hooks/use-feature-flags'
import { useIntl } from '@/i18n/hooks/use-intl'

const CampaignCta: FunctionComponent = () => {
  const { formatMessage } = useIntl()

  const { withFeature } = useFeatureFlags()

  return (
    <Container>
      <Image
        alt='Campaign CTA'
        height={310}
        src={campaignIntroSrc}
        width={450}
      />
      <Flex vertical align='center' gap={8}>
        <Title>
          {formatMessage({
            id: 'kol_cooperation_detail_drawer:tabs_campaign_collaboration_record_cta_title',
          })}
        </Title>
        <Description>
          {formatMessage({
            id: 'kol_cooperation_detail_drawer:tabs_campaign_collaboration_record_cta_description',
          })}
        </Description>
      </Flex>
      {withFeature(FeatureFlag.DualWheel) ? (
        <Button href={routes.campaignList.stringifyUrl({})} type='primary'>
          {formatMessage({ id: 'general:navigate_to_create' })}
        </Button>
      ) : (
        <RequestTrialButton />
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 30px;
`

const Title = styled.div`
  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 16px;
  font-weight: 700;
  line-height: 140%;
`

const Description = styled.div`
  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`

export default CampaignCta
